export default Object.freeze({
  Automatic: 1,
  Manual: 2,
});
